export const patchConsole = () => {

	if(patched) return;

	const cons = Object.assign({}, globalThis.console);

	globalThis.console.warn = ( message:string, ...args: unknown[] ) => {
		if(MODE !== "DEVELOPMENT" && Array.from(ignorePatterns).find(pattern => message.startsWith(pattern))) return;
		cons.warn(message, ...args);
		if(MODE === "DEVELOPMENT") {
			// cons.log("TRACE>>");
			// cons.trace();
		}
	};

	globalThis.console.log = ( message:string, ...args: unknown[] ) => {
		if(MODE !== "DEVELOPMENT" && Array.from(ignorePatterns).find(pattern => message.startsWith(pattern))) return;
		cons.warn(message, ...args);
		if(MODE === "DEVELOPMENT") {
			// cons.log("TRACE>>");
			// cons.trace();
		}

	};

	MODE = ["app.bracket.fi"].includes(globalThis.location.hostname) ? "PRODUCTION" : "DEVELOPMENT";
	patched = true;

};


let patched = false;
let MODE: "PRODUCTION" | "DEVELOPMENT" = "PRODUCTION";


const ignorePatterns = new Set<string>([
	"Lit is in dev mode",
	"GSAP target null not found",
	"The resource https://fonts.reown.com/KHTeka-Medium.woff2",
]);

